
import "/root/workspace/__flow_work/__flow_builds/4ed6d599-55a5-4f85-8534-0c858affe5ce/workspace/saas-admin/src/pages/Member/QuickOpenCard/components/StepComplete.less?modules";
export default {"finishCardMain": `finishCardMain-ZEYCLz9q`,"successPanel": `successPanel-WFP5RyWo`,"finishCardMeta": `finishCardMeta-VEKpFl7n`}
